<div class="bse-password-modal-container">
  <div class="modal-header p-2">
    <h2>{{ currentStep().title }}</h2>
    @if (currentStepIndex() < 3) {
      <button
        type="button"
        class="close-btn"
        (click)="closeModal()"
        aria-label="Close modal"
      >
        <i class="pi pi-times"></i>
      </button>
    }
  </div>

  <div class="modal-content">
    @switch (currentStep().step) {
      <!-- Step 1: Email Verification -->
      @case ('email') {
        <div class="step-content">
          <div class="step-description text-center">
            <p>{{ currentStep().description }}</p>
          </div>

          <form [formGroup]="emailForm" class="form-container">
            <div class="form-group">
              <label class="field-label"
                >Email Address <span class="required">*</span></label
              >
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-envelope"></i>
                </p-inputgroup-addon>
                <input
                  type="email"
                  pInputText
                  formControlName="email"
                  placeholder="Enter email address"
                />
              </p-inputgroup>

              @if (
                (emailForm.get('email')?.touched || submitEmailAttempt()) &&
                (emailForm.get('email')?.hasError('email') ||
                  emailForm.get('email')?.hasError('pattern'))
              ) {
                <small class="error-message"
                  >Please enter a valid email address</small
                >
              }
              @if (
                (emailForm.get('email')?.touched || submitEmailAttempt()) &&
                emailForm.get('email')?.hasError('required')
              ) {
                <small class="error-message">Email is required</small>
              }
              @if (emailError()) {
                <small class="error-message">{{ emailError() }}</small>
              }
            </div>
          </form>

          <div class="button-container text-center">
            <p-button
              label="Generate OTP"
              [loading]="isLoading()"
              (click)="generateOTP()"
              styleClass="primary-btn w-full"
              role="button"
              tabindex="0"
              (keydown.enter)="
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
              (keydown.space)="
                $event.target === $event.currentTarget &&
                  $event.preventDefault();
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
            />
          </div>
        </div>
      }

      <!-- Step 2: OTP Verification -->
      @case ('otp') {
        <div class="step-content">
          <div class="step-description text-center">
            <p>{{ currentStep().description }}</p>
          </div>

          <div class="email-display">
            <i class="pi pi-envelope"></i>
            <span>{{ userEmail() }}</span>
          </div>

          <form [formGroup]="otpForm" class="form-container">
            <p-inputOtp
              formControlName="otp"
              [length]="6"
              [integerOnly]="true"
              styleClass="otp-input"
            />

            @if (otpError()) {
              <small class="error-message text-center">{{ otpError() }}</small>
            }
          </form>

          <div class="button-container text-center">
            <p-button
              label="Verify OTP"
              [loading]="isLoading()"
              (click)="verifyOTP()"
              styleClass="primary-btn w-full"
              role="button"
              tabindex="0"
              (keydown.enter)="
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
              (keydown.space)="
                $event.target === $event.currentTarget &&
                  $event.preventDefault();
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
            />
          </div>
        </div>
      }

      <!-- Step 3: BSE Credentials -->
      @case ('credentials') {
        <div class="step-content">
          <div class="step-description text-center">
            <p>{{ currentStep().description }}</p>
          </div>

          <form [formGroup]="credentialsForm" class="form-container">
            <!-- BSE User ID Field -->
            <div class="form-group">
              <label class="field-label"
                >User ID (for BSE Star) <span class="required">*</span></label
              >
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  type="text"
                  pInputText
                  formControlName="bseUserId"
                  placeholder="Enter BSE User ID"
                />
              </p-inputgroup>

              @if (
                credentialsForm.get('bseUserId')?.touched &&
                credentialsForm.get('bseUserId')?.hasError('required')
              ) {
                <small class="error-message">User ID is required</small>
              }
            </div>

            <!-- BSE Member ID Field -->
            <div class="form-group">
              <label class="field-label"
                >Member ID (for BSE Star) <span class="required">*</span></label
              >
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-id-card"></i>
                </p-inputgroup-addon>
                <input
                  type="text"
                  pInputText
                  formControlName="bseMemberId"
                  placeholder="Enter BSE Member ID"
                />
              </p-inputgroup>

              @if (
                credentialsForm.get('bseMemberId')?.touched &&
                credentialsForm.get('bseMemberId')?.hasError('required')
              ) {
                <small class="error-message">Member ID is required</small>
              }
            </div>

            <!-- BSE Password Field -->
            <div class="form-group">
              <label class="field-label"
                >Password (for BSE Star) <span class="required">*</span></label
              >
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-lock"></i>
                </p-inputgroup-addon>
                <input
                  type="password"
                  pInputText
                  formControlName="newBsePassword"
                  placeholder="Enter BSE Password"
                />
              </p-inputgroup>

              @if (
                credentialsForm.get('newBsePassword')?.touched &&
                credentialsForm.get('newBsePassword')?.hasError('required')
              ) {
                <small class="error-message">Password is required</small>
              }
            </div>

            @if (credentialsError()) {
              <small class="error-message">{{ credentialsError() }}</small>
            }
          </form>

          <div class="button-container text-center">
            <p-button
              label="Submit"
              [loading]="isLoading()"
              (click)="submitBSECredentials()"
              styleClass="primary-btn w-full"
              role="button"
              tabindex="0"
              (keydown.enter)="
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
              (keydown.space)="
                $event.target === $event.currentTarget &&
                  $event.preventDefault();
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
            />
          </div>
        </div>
      }

      <!-- Step 4: Confirmation -->
      @case ('confirmation') {
        <div class="step-content confirmation-step">
          <div class="success-icon">
            <img
              src="assets/images/updatePass.png"
              alt="BSE Password Saved"
              class="success-image"
            />
          </div>

          <div class="confirmation-content">
            <p>{{ currentStep().description }}</p>
          </div>

          <div class="button-container">
            <p-button
              label="Logout"
              (click)="completeBSESetup()"
              styleClass="primary-btn w-full"
              role="button"
              tabindex="0"
              (keydown.enter)="
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
              (keydown.space)="
                $event.target === $event.currentTarget &&
                  $event.preventDefault();
                $event.target === $event.currentTarget &&
                  $any($event.currentTarget).click()
              "
            />
          </div>
        </div>
      }
    }
  </div>
</div>
